var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sort__group" }, [
    _c("a", {
      staticClass: "sort__layout sort__layout--1 sort__layout--active",
      on: {
        click: function ($event) {
          return _vm.setLayout("big")
        },
      },
    }),
    _vm._v(" "),
    _c("a", {
      staticClass: "sort__layout sort__layout--2",
      on: {
        click: function ($event) {
          return _vm.setLayout("small")
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }